import { FC, useRef, useState } from 'react';
import { t } from 'i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { getDeviceList, setSelectedRowsPerPage } from '../../../../store/slice/health-monitor/device-list';
import arrow from '../../../../assets/img/png/health-monitor/rows-per-page-arrow.png';
import { useOutsideFocus } from '../../../../hook/useOutsideFocus';

const availableRowsPerPage = [20, 40];

const RowsPerPageMenu: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const selectedRowsPerPage = useAppSelector((state) => state.deviceList.selectedRowsPerPage);
  const isThumbnailView = useAppSelector((state) => state.configSlice.isThumbnailView);
  const menuRef = useRef<HTMLUListElement>(null);
  const dispatch = useAppDispatch();

  useOutsideFocus(isOpen, () => setIsOpen(false), menuRef);

  const handleRowsPerPageChange = (newRowsPerPage: number) => {
    dispatch(setSelectedRowsPerPage(newRowsPerPage));
    dispatch(getDeviceList());
  };

  return (
    <span ref={menuRef} className="rows_per_page" onClick={() => setIsOpen((prevState) => !prevState)}>
      {isThumbnailView
        ? t('healthMonitor.footer.pagination.thumbnailsPerPage')
        : t('healthMonitor.footer.pagination.rowsPerPage')}
      <span className="count">{selectedRowsPerPage}</span>
      <img className={`arrow_icon ${isOpen ? 'rotated' : ''}`} src={arrow} alt="upside_down_arrow"></img>
      <ul className={`menu ${isOpen ? 'open' : ''}`}>
        {availableRowsPerPage.map((rowsPerPage, index) => (
          <li key={`${rowsPerPage}-${index}`} onClick={() => handleRowsPerPageChange(rowsPerPage)}>
            {rowsPerPage}
          </li>
        ))}
      </ul>
    </span>
  );
};

export default RowsPerPageMenu;
